import { Injectable } from '@angular/core';
import { CatalogoService } from './catalogo.service';
import { AngularFireDatabase, SnapshotAction } from '@angular/fire/database';
import { map, first, filter, find, switchMap, take } from 'rxjs/operators';
import { Observable, from } from 'rxjs';
import { Rol } from 'src/app/models/entities/rol';

@Injectable({
  providedIn: 'root'
})
export class RolService {
  public path: string = 'catalogos/catRoles/catalogo';
  constructor(private angularFireDatabase: AngularFireDatabase) { }

  public findAll(): Observable<Rol[]> {
    return this.angularFireDatabase.list<Rol>(this.path).snapshotChanges().pipe(
      map(
        changes =>
          changes.map(c => (
            ({
              key: c.payload.key,
              ...c.payload.val()
            } as Rol)
          ))
      )
    );
  }

  public findByKeyRol(keyRol: string): Observable<Rol> {
    return this.angularFireDatabase.object<Rol>(`${this.path}/${keyRol}`).snapshotChanges().pipe(
      map((c: SnapshotAction<Rol>) => (
        {
          key: c.payload.key,
          ...c.payload.val()
        } as Rol
      ))
    );
  }

  public obtenerRolUsuarioGeneral(): Observable<Rol> {
    return this.findAll()
      .pipe(
        switchMap(
          (elementosCatalogo: Rol[]) => from(elementosCatalogo)
            .pipe(
              find((e: Rol) => e.key === '5')
            )
        ));
  }

  public obtenerRolUsuarioAdministrador(): Observable<Rol> {
    return this.findAll()
      .pipe(
        switchMap(
          (elementosCatalogo: Rol[]) => from(elementosCatalogo)
            .pipe(
              find((e: Rol) => e.key === '0')
            )
        ));
  }


}
